import { SSO_TOKEN_NAME, SSO_REFRESH_TOKEN_NAME } from "../utils/sso_utils";

export function navBack(): void {
  document.body.style.opacity = "0";
  document.body.style.transition = "all 0.05s cubic-bezier(0.645, 0.045, 0.355, 1)";
  // const previousPage = localStorage.getItem("previousPage");
  // document.location.assign(previousPage !== null ? previousPage : "menu.html");
  document.location.href = "menu.html";
}

export function logout(): void {
  document.body.style.opacity = "0";
  document.body.style.transition = "all 0.05s cubic-bezier(0.645, 0.045, 0.355, 1)";

  localStorage.removeItem("authToken");
  localStorage.removeItem("username");
  localStorage.removeItem(SSO_TOKEN_NAME);
  localStorage.removeItem(SSO_REFRESH_TOKEN_NAME);

  document.location.replace("login.html");
}

export function navSubPage(subPageUrl: string): void {
  document.body.style.opacity = "0";
  document.body.style.transition = "all 0.05s cubic-bezier(0.645, 0.045, 0.355, 1)";
  document.location.href = subPageUrl;
}

export async function cmClick1(event: Office.AddinCommands.Event) {
  try {
    const context = Word.run(async (context) => {
      let selection = context.document.getSelection();
      selection.load("text");

      await context.sync();
      console.log("Markierter Text:", selection.text);

      // Hier eigene Logik einfügen, z.B. Text ersetzen oder formatieren
      if (selection.text.length > 0) {
        selection.font.highlightColor = "yellow";
      }

      await context.sync();
    });

    event.completed(); // Wichtig: Signalisiert Office, dass das Event verarbeitet wurde
  } catch (error) {
    console.error("Fehler beim Kontextmenü-Handler:", error);
  }
}

export async function cmClick2(event: Office.AddinCommands.Event) {
  try {
    const context = Word.run(async (context) => {
      let selection = context.document.getSelection();
      selection.load("text");

      await context.sync();
      console.log("Markierter Text:", selection.text);

      // Hier eigene Logik einfügen, z.B. Text ersetzen oder formatieren
      if (selection.text.length > 0) {
        selection.insertText(selection.text.toUpperCase(), Word.InsertLocation.replace);
      }

      await context.sync();
    });

    event.completed(); // Wichtig: Signalisiert Office, dass das Event verarbeitet wurde
  } catch (error) {
    console.error("Fehler beim Kontextmenü-Handler:", error);
  }
}

export function checkScrollbar(elementToCheck: HTMLElement): void {
  if (elementToCheck.scrollHeight > elementToCheck.clientHeight) {
    elementToCheck.style.paddingRight = "5px";
  } else {
    elementToCheck.style.paddingRight = "0px";
  }
}
